import React, { useRef } from 'react';
var VeltNotificationsPanelCloseButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-close-button", { ref: ref }, children));
};
export default VeltNotificationsPanelCloseButton;
